import './App.css';
import Router from './Router';
import { initMonitoring } from "@kfintech/website-monitoring-sdk";

function App() {
  initMonitoring({
    appName: "PMS",
    env: "prod",
    apiUrl: "/Analysis/WebsiteMonitoringSaving",
    enableClicks: false,
    enableErrors: true,
    enableVitals: true,
    sampleRate: 0.3,
    debug: false,
    maskKeys: [
      "password",
      "token",
      "pan",
      "aadhaar",
    ],
  })
  return (
    <>
      <Router />
    </>
  );
}
export default App;
